import { Types } from "../Constants/Types";
import CheckoutType from "../Interfaces/checkout.interface";

const initialState: CheckoutType['status'] = {
  checkout: undefined,
  lcheckout: false,
  error: ""
};

const CheckoutReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Types.START_CHECKOUT:
      return { ...state, lcheckout: true };
    case Types.END_CHECKOUT:
      return { ...state, lcheckout: false };
    case Types.FETCH_CHECKOUT:
      return { ...state, checkout: action.payload };
    case Types.ERROR_CHECKOUT:
      return { ...state, error: action.payload };
    default:
      return state;
  }
};

export default CheckoutReducer; 